export const currencies = [
    {
        entity: 'NORWAY',
        flag: 'nor',
        currency: 'Norwegian Krone',
        alphabetic: 'NOK',
        numeric: '578',
        minorUnit: '2',
    },
    {
        entity: 'SWEDEN',
        flag: 'swe',
        currency: 'Swedish Krona',
        alphabetic: 'SEK',
        numeric: '752',
        minorUnit: '2',
    },
    {
        entity: 'EUROPEAN UNION',
        flag: 'eur',
        currency: 'Euro',
        alphabetic: 'EUR',
        numeric: '978',
        minorUnit: '2',
    },
    {
        entity: 'UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND (THE)',
        flag: 'eng',
        currency: 'Pound Sterling',
        alphabetic: 'GBP',
        numeric: '826',
        minorUnit: '2',
    },
    {
        entity: 'UNITED STATES OF AMERICA (THE)',
        flag: 'usa',
        currency: 'US Dollar',
        alphabetic: 'USD',
        numeric: '840',
        minorUnit: '2',
    },
]
